import { render, staticRenderFns } from "./BookForm.vue?vue&type=template&id=2643acda&scoped=true&"
import script from "./BookForm.vue?vue&type=script&lang=ts&"
export * from "./BookForm.vue?vue&type=script&lang=ts&"
import style0 from "./BookForm.vue?vue&type=style&index=0&id=2643acda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2643acda",
  null
  
)

export default component.exports